import { render, staticRenderFns } from "./fullSizeImg.vue?vue&type=template&id=2d70dbac&scoped=true&"
import script from "./fullSizeImg.vue?vue&type=script&lang=js&"
export * from "./fullSizeImg.vue?vue&type=script&lang=js&"
import style0 from "./fullSizeImg.vue?vue&type=style&index=0&id=2d70dbac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d70dbac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VParallax,VRow})
